import { Box, Typography } from "@mui/material";
import MyButton from "../MuiReusableComponents/MuiButton/buttonMUI";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
const DeletePopup = ({ onClickYes, onClickNo }) => {
  return (
    <>
      <Box sx={{  display: "flex", justifyContent: "center", alignItems:"center" }}>
        <Typography>Do you want to delete this record? </Typography>
      </Box>
      <Box sx={{ p: "5px 0 0 0",display: "flex", justifyContent: "center", alignItems:"center" }}>
        <MyButton
          size="small"
          // endIcon={<PriorityHighIcon color="error" />}
          onClick={onClickYes}
          variant="contained"
        >
          Yes{" "}
        </MyButton>
        <MyButton size="small" sx={{ marginLeft: "20px" }} onClick={onClickNo}>
          No
        </MyButton>
      </Box>
    </>
  );
};
export default DeletePopup;
